export default __webpack_public_path__ + "static/media/u_trash-alt.3abc92bd.svg";